<template>
  <v-menu bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <BaseAvatar :img="pic" />
        <v-icon class="hidden-sm-and-down">arrow_drop_down</v-icon>
      </div>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, i) in menu"
        :key="i"
        @click="navigate(item)"
      >
        <v-list-item-icon class="mr-4">
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title class="pr-6">
          {{ $t(item.name) }}
        </v-list-item-title>
      </v-list-item>

      <v-divider class="mt-2"></v-divider>

      <v-list-item
        class="text-xs-center mt-2"
        v-for="locale in otherLocales"
        :key="locale"
        @click="changeLocale(locale)"
      >
        <v-list-item-title>
          {{ $t('SWITCH_LANG', locale)}}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped>
>>> .v-list-item__icon {
  max-width: 24px;
}
</style>

<script>
export default {
  name: 'ProfileIconDropdown',
  data: () => ({
    menu: [
      {
        name: 'LOGOUT',
        icon: 'logout',
        to: 'logout',
      },
    ],
  }),
  computed: {
    pic() {
      const { session } = this.$store.state;
      if (session.isLoading) {
        return '';
      }

      return session.pic;
    },
    otherLocales() {
      return this.$i18n.availableLocales.filter((lang) => lang !== this.$i18n.locale);
    },
  },
  methods: {
    navigate(item) {
      if (item.to === 'logout') {
        this.$track('logout', 'navbar');
      }
      this.$router.push({ name: item.to });
    },
    changeLocale(locale) {
      this.$track('lang_switch', 'navbar', locale);
      this.$store.dispatch('settings/store', { lang: locale });
    },
  },
  created() {
    if (this.$store.state.session.isAnonymous) {
      this.menu = [
        {
          name: 'REGISTER.MENU_TEXT',
          icon: 'person',
          to: 'register',
        },
        {
          name: 'LOGIN.TITLE',
          icon: 'login',
          to: 'login',
        },
        ...this.menu,
      ];
    } else {
      this.menu = [
        {
          name: 'PROFILE.MY_PROFILE',
          icon: 'person',
          to: 'profile',
        },
        ...this.menu,
      ];
    }
  },
};
</script>
